import { render, staticRenderFns } from "./ChooseEquityTable.vue?vue&type=template&id=63e81054&scoped=true"
import script from "./ChooseEquityTable.vue?vue&type=script&lang=js"
export * from "./ChooseEquityTable.vue?vue&type=script&lang=js"
import style0 from "./ChooseEquityTable.vue?vue&type=style&index=0&id=63e81054&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e81054",
  null
  
)

export default component.exports